// Opções de escopo da regra de comissão.
//
// No backend o escopo por tipo é uma coisa só (scopeType PRODUCT_TYPE) com um alvo à parte
// (scopeProductType PRODUCT ou SERVICE). Na tela isso vira duas opções soltas na mesma lista,
// porque "somente produtos" é uma escolha inteira na cabeça de quem cadastra: obrigá-lo a
// escolher "por tipo" e depois "produto" seriam dois passos para uma decisão só.
//
// O achatamento acontece aqui e a tradução de volta também, para o formulário e o filtro não
// implementarem cada um o seu.

export const SCOPE_VALUE = {
    PRODUCT: 'PRODUCT',
    CATEGORY: 'CATEGORY',
    ONLY_PRODUCTS: 'ONLY_PRODUCTS',
    ONLY_SERVICES: 'ONLY_SERVICES',
    ALL: 'ALL'
};

// Ordem da mais específica para a mais ampla, a mesma do desempate do backend, para a lista
// não sugerir uma hierarquia diferente da que o cálculo usa.
export const getScopeOptions = (t) => [
    { value: SCOPE_VALUE.PRODUCT, label: t('commission_scope_product') },
    { value: SCOPE_VALUE.CATEGORY, label: t('commission_scope_category') },
    { value: SCOPE_VALUE.ONLY_PRODUCTS, label: t('commission_scope_only_products') },
    { value: SCOPE_VALUE.ONLY_SERVICES, label: t('commission_scope_only_services') },
    { value: SCOPE_VALUE.ALL, label: t('commission_scope_all') }
];

/** Par (scopeType, scopeProductType) que a opção da tela representa no backend. */
export const toBackendScope = (value) => {
    if (value === SCOPE_VALUE.ONLY_PRODUCTS) {
        return { scopeType: 'PRODUCT_TYPE', scopeProductType: 'PRODUCT' };
    }
    if (value === SCOPE_VALUE.ONLY_SERVICES) {
        return { scopeType: 'PRODUCT_TYPE', scopeProductType: 'SERVICE' };
    }
    return { scopeType: value, scopeProductType: null };
};

/** Caminho inverso, usado na edição para reabrir o select na opção certa. */
export const toFormScope = (scopeType, scopeProductType) => {
    if (scopeType !== 'PRODUCT_TYPE') {
        return scopeType;
    }
    return scopeProductType === 'SERVICE' ? SCOPE_VALUE.ONLY_SERVICES : SCOPE_VALUE.ONLY_PRODUCTS;
};

/** Escopos que exigem o operador escolher um produto ou uma categoria. */
export const requiresTarget = (value) =>
    value === SCOPE_VALUE.PRODUCT || value === SCOPE_VALUE.CATEGORY;

